import { useMemo, useState } from 'react';
import { Button, Card, Col, ProgressBar, Row } from 'react-bootstrap';

interface ProfileProgressProps {
  progress: number;
  compact?: boolean;
  className?: string;
}

export const ProfileProgress = ({ compact, className, progress }: ProfileProgressProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const rowClassName = useMemo(() => (compact ? 'flex-column' : 'align-items-center'), [compact]);
  const colClassName = useMemo(
    () => `profile-progress--count__column ${compact ? 'mb-2' : ''}`,
    [compact]
  );
  const cardClassName = useMemo(
    () => `profile-progress text-start ${compact ? 'compact p-3' : 'px-2'} ${className}`,
    [className, compact]
  );

  const handleClick = (_e: React.MouseEvent) => {
    setIsLoading(true);
    window.location.href = '/app/provider/onboarding';
  };

  return (
    <Card className={cardClassName}>
      <Card.Body>
        {!compact && (
          <>
            <Card.Title className="fs-5 mb-2 pe-1">
              <Button
                size="sm"
                className="d-block my-2 py-1 px-2 shadow bg-danger"
                disabled={isLoading}
                onClick={handleClick}
              >
                {isLoading ? 'Loading...' : 'Finish Onboarding'}
              </Button>
            </Card.Title>
            <Card.Text className="small profile-progress--text mb-2 pt-1">
              In order to be listed on the Marketplace, you need to complete the onboarding process.
            </Card.Text>
          </>
        )}
        <Row className={rowClassName}>
          <Col xs="auto" className={colClassName}>
            <span className="fw-bold profile-progress--count">
              {progress}% {compact && 'complete'}
            </span>
          </Col>
          <Col>
            <ProgressBar className="profile-progress--bar" now={progress} />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
